import { FC } from 'react'

import { SequenceMenu } from '@sequencehq/core-components'

import { CancelApprovalModal } from 'common/modals/quotes/CancelApproval.modal'

export const CancelApprovalMenuItem: FC<{ onSubmit?: () => void }> = ({
  onSubmit
}) => {
  return (
    <CancelApprovalModal
      trigger={
        <SequenceMenu.Item
          uuid="cancel-approval"
          label="Cancel review request"
          data-testid="quotes.cancelApproval.menuItem"
        />
      }
      onSubmit={onSubmit}
    />
  )
}
